var _path, _path2, _g, _rect, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7679 13.6199V14.1652L33.2865 14.3334C35.2972 14.9855 36.7554 16.8884 36.7554 19.0405C36.7554 22.1126 37.4222 24.4311 39.5761 26.7196L39.577 26.7206C39.9384 27.1033 39.9642 27.4841 39.8823 27.7161C39.8064 27.9312 39.602 28.1347 39.1877 28.1347H24.4836C24.0693 28.1347 23.8649 27.9312 23.789 27.7161C23.7071 27.4841 23.7328 27.1033 24.0943 26.7206L24.0952 26.7196C26.2491 24.4311 26.9159 22.1126 26.9159 19.0405C26.9159 16.8884 28.3741 14.9855 30.3848 14.3334L30.9034 14.1652V13.6199C30.9034 13.1801 31.2968 12.75 31.8356 12.75C32.3745 12.75 32.7679 13.1801 32.7679 13.6199Z",
    stroke: "#50595F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.789 30.2578H33.8822C33.4072 30.8612 32.6674 31.25 31.8356 31.25C31.0038 31.25 30.2641 30.8612 29.789 30.2578Z",
    stroke: "#50595F",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_417)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5179 57.6199C35.8232 58.3676 37.5054 60.5483 37.5054 63.0405C37.5054 65.9688 38.1285 68.0872 40.1222 70.2056C41.1814 71.3271 40.6207 72.8847 39.1877 72.8847H24.4836C23.0506 72.8847 22.4898 71.3271 23.549 70.2056C25.5428 68.0872 26.1659 65.9688 26.1659 63.0405C26.1659 60.5483 27.8481 58.3676 30.1534 57.6199C30.1534 56.7477 30.9011 56 31.8356 56C32.7702 56 33.5179 56.7477 33.5179 57.6199Z",
    fill: "url(#paint0_linear_1_417)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0755 73.5078C34.7017 74.9408 33.3932 76 31.8356 76C30.278 76 28.9696 74.9408 28.5957 73.5078H35.0755Z",
    fill: "url(#paint1_linear_1_417)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 64,
    height: 44,
    fill: "#3C82F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5179 101.62C35.8232 102.368 37.5054 104.548 37.5054 107.04C37.5054 109.969 38.1285 112.087 40.1222 114.206C41.1814 115.327 40.6207 116.885 39.1877 116.885H24.4836C23.0506 116.885 22.4898 115.327 23.549 114.206C25.5428 112.087 26.1659 109.969 26.1659 107.04C26.1659 104.548 27.8481 102.368 30.1534 101.62C30.1534 100.748 30.9011 100 31.8356 100C32.7702 100 33.5179 100.748 33.5179 101.62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0755 117.508C34.7017 118.941 33.3932 120 31.8356 120C30.278 120 28.9696 118.941 28.5957 117.508H35.0755Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_417",
    x: 19,
    y: 54,
    width: 25.6713,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.223529 0 0 0 0 0.729412 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_417",
    x1: 31.8356,
    y1: 56,
    x2: 31.8356,
    y2: 72.8847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_417",
    x1: 31.8356,
    y1: 73.5078,
    x2: 31.8356,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.01ac272e96f87764c121983a6ad98efa.svg";
export { ForwardRef as ReactComponent };